import { createFileRoute, Outlet } from '@tanstack/react-router'

/** The signed-in user's own commission: open to everyone signed in (the API serves only their own). */
export const Route = createFileRoute('/_app/commissions/mine')({
  staticData: { crumb: 'myCommission' },
  component: Outlet,
})
